module.exports = __webpack_public_path__ + "img/terroir-grid-3-mobile.34d421c8.jpg";